import React from "react";
import styles from "./Total.module.scss";

const Total = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <h4>Total Collections</h4>
      </div>
      <div className={styles.right}>
        <div className={styles.progressContainer}>
          <p>03/25</p>
          <div className={styles.progressBar}>
            <div className={styles.progress}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Total;
